import axios from "axios";

export default function ModulesListService() {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/modules",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
